import { lazy } from "react";

const LandingPage = lazy(() => import("./Landing.page"));
export { LandingPage };
